export default "__VITE_ASSET__jenp2lav__"